<div class="product-box">
  <a [routerLink]="thumbnail.safeProductUrl" title="{{thumbnail.title}}">
    <div class="product-image">
      <img [src]="thumbnail.safeImageUrl" [alt]="thumbnail.title" [appImgSrcSet]="thumbnail.originalImageUrl" sizes="250px" />
      <div class="product-masking">
      </div>
    </div>
  </a>
  <div class="product-caption">
    <div class="row">
      <div class="col">
        <a [routerLink]="thumbnail.safeProductUrl" title="{{thumbnail.title}}">
          <h5>{{thumbnail.title}}</h5>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="price" *ngIf="thumbnail.metadata.saleActive">
          <span class="standard-price">{{thumbnail.formattedStandardPrice}}</span>
          <span class="sale-price"> {{thumbnail.formattedPrice}}</span>
        </div>
        <div class="price" *ngIf="!thumbnail.metadata.saleActive">
          <div>{{thumbnail.formattedPrice}}</div>
        </div>
      </div>
      <div class="favourites">
        <a id="add-to-favourites-{{index}}" *ngIf="!favouritesService.favouritesMap[thumbnail.code]"
          (click)="addToFavourites()">
          <i class="far fa-heart"></i>
        </a>
        <a id="remove-from-favourites-{{index}}" *ngIf="favouritesService.favouritesMap[thumbnail.code]"
          (click)="removeFromFavourites()">
          <i class="fas fa-heart"></i>
        </a>
      </div>
    </div>
  </div>
</div>